import { USER as user } from './user';

export const SETTINGS = {
  user
};
